var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-video grid grid__base" }, [
    _c("div", { staticClass: "hero-video--container" }, [
      _c("video", {
        staticClass: "hero-video--player",
        attrs: { muted: "", autoplay: "", loop: "", src: _vm.video },
        domProps: { muted: true }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid--container hero-video--title-container" },
        [
          _c("h1", { staticClass: "hero-video--title u-reset" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "hero-video--next-button",
          on: { click: _vm.goToNextSection }
        },
        [
          _c("base-icon", {
            staticClass: "hero-video--icon",
            attrs: { symbol: "arrow-forward", size: "large" }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b406f18", { render: render, staticRenderFns: staticRenderFns })
  }
}